import { FC } from "react";
import { Button,  Input, Row, Typography } from "antd";
import { FilterWrapper, StyledSearch, StyledText, Wrapper } from "./styled";
import { Sort } from "../icons/Sort";
import { TSortState } from "../../types";
import { SearchIcon } from "../icons/SearchIcon";

interface ISearchSortBlockProps {
  changeSort: ({ sort, direction }: TSortState) => void;
  currentSort: TSortState;
  handleSearch: (value: string) => void;
  search: string;
  sortArray: string[];
}

export const SearchSortBlock: FC<ISearchSortBlockProps> = ({
  changeSort,
  currentSort,
  handleSearch,
  search,
  sortArray,
}) => {
  const reverseSorting = () =>
    currentSort.direction === "asc" ? "desc" : "asc";

  const toggleFilter = (sort: string) => {
    const newSortDirection =
      currentSort.sort === sort ? reverseSorting() : "asc";

    changeSort({ direction: newSortDirection, sort });
  };

  return (
    <Wrapper>
      <StyledSearch>
        <Typography.Text>Поиск</Typography.Text>

        <Input style={{paddingRight: "50px"}}
          prefix={<SearchIcon />}
          size="middle"
          placeholder=" Введите запрос"
        />
      </StyledSearch>

      <StyledText>
        <Typography.Text strong style={{ padding: "4px 15px 6px 15px" }}>
          Сортировать:
        </Typography.Text>
      </StyledText>

      {sortArray.map((el) => {
        const isActive = currentSort.sort === el;

        return (
          <FilterWrapper
            $isActive={isActive}
            $isDirectionReversed={isActive && currentSort.direction === "desc"}
            key={el}
            onClick={() => toggleFilter(el)}
          >
            <Row align="bottom">
              <Button type="link">{el}</Button>
              <Sort />
            </Row>
          </FilterWrapper>
        );
      })}
    </Wrapper>
  );
};
